<template>
  <div class="userTariff">
    <header class="header">
      <div class="header-inner">
        <h1 class="header-title">
          {{
            $store.state.auth.role == "branch_admin"
              ? "مدیریت تعرفه"
              : "خرید تعرفه"
          }}
        </h1>
        <button class="back-btn" @click="historyBackHandler">
          <i class="fas fa-arrow-left"></i>
        </button>
      </div>
    </header>

    <div class="page-wrapper">
      <div v-if="tariffLoading" class="col-main">
        <Skeletor class="section-title-sk" />

        <div class="active-tariffs-grid">
          <Skeletor
            v-for="i in 3"
            :key="i"
            class="active-tariff-item-sk"
            :class="{
              twoColumn: i == 3,
            }"
          />
        </div>

        <Skeletor class="section-title-sk" />

        <div class="tariff-list">
          <Skeletor v-for="i in 6" :key="i" class="tariff-card-sk" />
        </div>
      </div>
      <div v-if="!tariffLoading" class="col-main">
        <p v-if="hasTariffList.length > 0" class="section-title">
          تعرفه‌های فعال شما
        </p>

        <div v-if="hasTariffList.length > 0" class="active-tariffs-grid">
          <div
            v-for="(tariff, i) in hasTariffList"
            :key="tariff.id"
            class="active-tariff-item"
            :class="{
              twoColumn:
                i == hasTariffList.length - 1 &&
                hasTariffList.length % 2 != 0,
            }"
          >
            <div class="active-tariff-top">
              <div class="active-tariff-dot"></div>
              <div class="active-tariff-name">{{ tariff.title }}</div>
            </div>
            <div class="active-tariff-bottom">
              <span class="active-tariff-num">{{ tariff.left }}</span>
              <span class="active-tariff-label">عدد باقی‌مانده</span>
            </div>
          </div>
        </div>

        <p v-if="activeTariffList.length > 0" class="section-title">انتخاب تعرفه</p>

        <div v-if="activeTariffList.length > 0" class="tariff-list">
          <div
            v-for="tariff in activeTariffList"
            :key="tariff.id"
            class="tariff-card"
            :class="{ selected: tariff.selected }"
            @click="toggleCard(tariff)"
          >
            <div class="tariff-main">
              <div class="tariff-left">
                <div class="tariff-name">{{ tariff.title }}</div>
                <div class="tariff-price-label">
                  هر عدد <strong>{{ fmt(tariff.price) }}</strong> تومان
                </div>
              </div>
              <div class="tariff-checkbox">
                <svg width="11" height="11" viewBox="0 0 12 12" fill="none">
                  <polyline
                    points="2,6 5,9 10,3"
                    stroke="#fff"
                    stroke-width="2.2"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                  />
                </svg>
              </div>
            </div>
            <div class="tariff-counter-row">
              <div class="tariff-counter-inner">
                <div class="tariff-counter-wrap">
                  <span class="counter-label">تعداد مورد نیاز</span>
                  <div class="counter-controls">
                    <button
                      class="c-btn"
                      @click.stop.prevent="changeCount(tariff, -1)"
                    >
                      −
                    </button>
                    <span class="c-val">{{ tariff.count }}</span>
                    <button
                      class="c-btn"
                      @click.stop.prevent="changeCount(tariff, 1)"
                    >
                      +
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <aside class="col-sidebar">
        <div class="summary-card">
          <div class="summary-card-title">خلاصه سفارش</div>

          <div class="summary-items">
            <div v-if="!hasSelected" class="summary-empty">
              هنوز تعرفه‌ای انتخاب نشده
            </div>
            <div
              v-for="tariff in selectedTariffs"
              :key="tariff.id"
              class="summary-item"
            >
              <span class="summary-item-name">{{ tariff.title }}</span>
              <div class="summary-item-right">
                <span class="summary-item-qty">× {{ tariff.count }}</span>
                <span class="summary-item-price"
                  >{{ fmt(tariff.price * tariff.count) }} ت</span
                >
              </div>
            </div>
          </div>

          <div class="summary-divider"></div>

          <div class="wallet-row">
            <div class="wallet-left-side">
              <div>
                <div class="wallet-lbl">استفاده از کیف پول</div>
                <div class="wallet-bal">
                  موجودی: {{ fmt(walletBal) }} {{ $store.state.c_set.currency }}
                </div>
              </div>
            </div>
            <label class="toggle">
              <input type="checkbox" v-model="with_credit" />
              <span class="slider"></span>
            </label>
          </div>

          <div class="summary-divider"></div>

          <div class="total-row">
            <span class="total-lbl">مبلغ قابل پرداخت</span>
            <span class="total-val"
              >{{ fmt(finalTotal) }}<span>تومان</span></span
            >
          </div>

          <button
            v-if="!buyLoading"
            class="btn-buy"
            :disabled="!hasSelected"
            @click="buyTariffHandler"
          >
            خرید تعرفه
          </button>
          <div v-if="buyLoading" class="btn-buy">
            <div class="whiteLoader"></div>
          </div>
          <button
            v-if="$store.state.auth.role == 'branch_admin'"
            class="btn-transfer"
            :disabled="!hasSelected"
            @click="showConsultantHandler"
          >
            انتقال تعرفه
          </button>
        </div>
      </aside>
    </div>

    <div class="bottom-fixed">
      <div
        class="btn-row"
        :class="{ singleColumn: $store.state.auth.role != 'branch_admin' }"
      >
        <button
          v-if="!buyLoading"
          class="btn-buy-mobile"
          :disabled="!hasSelected"
          @click="showPurchaseHandler"
        >
          <svg
            width="18"
            height="18"
            viewBox="0 0 24 24"
            fill="none"
            stroke="currentColor"
            stroke-width="2"
            stroke-linecap="round"
            stroke-linejoin="round"
          >
            <circle cx="9" cy="21" r="1" />
            <circle cx="20" cy="21" r="1" />
            <path
              d="M1 1h4l2.68 13.39a2 2 0 0 0 2 1.61h9.72a2 2 0 0 0 2-1.61L23 6H6"
            />
          </svg>
          خرید تعرفه
        </button>

        <div v-if="buyLoading" class="btn-buy-mobile">
          <div class="whiteLoader"></div>
        </div>
        <button
          v-if="$store.state.auth.role == 'branch_admin'"
          class="btn-transfer-mobile"
          :disabled="!hasSelected"
          @click="showConsultantHandler"
        >
          انتقال تعرفه
        </button>
      </div>
    </div>

    <div
      class="contractsOverlay"
      :class="{ open: showConsultant }"
      @click="closeConsultantHandler"
    >
      <div class="overlayContent contractsContent" @click.stop>
        <div class="contentHandle"></div>
        <div class="contentHeader">
          <div class="headerTitle">انتقال تعرفه به</div>
          <div class="headerBackBtn" @click="closeConsultantHandler">✕</div>
        </div>
        <div class="contentMain">
          <div v-if="consultantLoading" class="mainList">
            <Skeletor class="listThumbSk" v-for="i in 4" :key="i" />
          </div>
          <div
            v-else-if="!consultantLoading && consultantList.length > 0"
            class="mainList"
          >
            <div
              v-for="(v, i) in consultantList"
              :key="i"
              class="listThumb"
              :class="{ selected: selectedConsultant == v.uid }"
              @click="selectConsultantHanlder(v.uid)"
            >
              <div class="thumbContent">
                <div class="contentProfile">
                  <img :src="v.avatar" :alt="v.nickname" />
                </div>
                <div class="contentName">
                  {{ v.nickname }}
                </div>
              </div>
              <div class="thumbCheck"></div>
            </div>
          </div>
        </div>
        <div class="contentFooter">
          <button
            v-if="!transferLoading"
            class="footerSubmit"
            :disabled="!selectedConsultant"
            @click="transferTariffHandler"
          >
            تایید انتقال
          </button>
          <div v-if="transferLoading" class="footerSubmit">
            <div class="whiteLoader"></div>
          </div>
        </div>
      </div>
    </div>
    <div
      class="purchaseOverlay"
      :class="{ open: showPurchase }"
      @click="historyBackHandler"
    >
      <div class="overlayContent" @click.stop>
        <div class="contentHandle"></div>
        <div class="contentHeader">
          <div class="headerTitle">پرداخت و خرید</div>
          <div class="headerBackBtn" @click="historyBackHandler">✕</div>
        </div>
        <div class="contentMain">
          <div class="summary-items">
            <div
              v-for="tariff in selectedTariffs"
              :key="tariff.id"
              class="summary-item"
            >
              <span class="summary-item-name">{{ tariff.title }}</span>
              <div class="summary-item-right">
                <span class="summary-item-qty">× {{ tariff.count }}</span>
                <span class="summary-item-price"
                  >{{ fmt(tariff.price * tariff.count) }} ت</span
                >
              </div>
            </div>
          </div>

          <div class="wallet-row">
            <div class="wallet-left-side">
              <div>
                <div class="wallet-lbl">استفاده از کیف پول</div>
                <div class="wallet-bal">
                  موجودی: {{ fmt(walletBal) }} {{ $store.state.c_set.currency }}
                </div>
              </div>
            </div>
            <label class="toggle">
              <input type="checkbox" v-model="with_credit" />
              <span class="slider"></span>
            </label>
          </div>

          <div class="total-row">
            <span class="total-lbl">مبلغ قابل پرداخت</span>
            <span class="total-val"
              >{{ fmt(finalTotal) }}<span>تومان</span></span
            >
          </div>
        </div>
        <div class="contentFooter">
          <button
            v-if="!buyLoading"
            class="footerSubmit"
            :disabled="!hasSelected"
            @click="buyTariffHandler"
          >
            پرداخت
          </button>
          <div v-if="buyLoading" class="footerSubmit">
            <div class="whiteLoader"></div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { Skeletor } from "vue-skeletor";
import { toast } from "vue3-toastify";

export default {
  name: "BuyTariff",
  components: {
    Skeletor,
  },
  data() {
    return {
      walletBal: this.$store.state.auth.credit,
      with_credit: false,
      allTariffList: [],
      activeTariffList: [],
      tariffLoading: false,
      buyLoading: false,
      consultantList: [],
      consultantLoading: false,
      selectedConsultant: null,
      transferLoading: false,
      countLocks: {},
    };
  },

  computed: {
    hasTariffList() {
      return this.allTariffList.filter((t) => t.left != 0);
    },
    selectedTariffs() {
      return this.activeTariffList.filter((t) => t.selected);
    },
    hasSelected() {
      return this.selectedTariffs.length > 0;
    },
    rawTotal() {
      return this.selectedTariffs.reduce(
        (sum, t) => sum + Number(t.price) * t.count,
        0
      );
    },
    finalTotal() {
      return this.with_credit
        ? Math.max(0, this.rawTotal - this.walletBal)
        : this.rawTotal;
    },
    selectedPayload() {
      return this.selectedTariffs.reduce((obj, t) => {
        obj[t.id] = t.count;
        return obj;
      }, {});
    },
    showConsultant() {
      const active = this.$route.query.consultant;
      return active ? true : false;
    },
    showPurchase() {
      const active = this.$route.query.purchase;
      return active ? true : false;
    },
  },

  methods: {
    fmt(n) {
      return Number(n).toLocaleString("fa-IR");
    },
    toggleCard(tariff) {
      tariff.selected = !tariff.selected;
    },
    changeCount(tariff, delta) {
      const key = `${tariff.id}_${delta}`;
      if (this.countLocks[key]) return;

      this.countLocks[key] = true;
      tariff.count = Math.max(1, tariff.count + delta);

      setTimeout(() => {
        delete this.countLocks[key];
      }, 150);
    },
    historyBackHandler() {
      history.back();
    },
    closeConsultantHandler() {
      this.selectedConsultant = null;
      this.consultantList = [];
      history.back();
    },
    showPurchaseHandler() {
      this.$router.push({
        query: {
          ...this.$route.query,
          ["purchase"]: "active",
        },
      });
    },
    showConsultantHandler() {
      this.$router.push({
        query: {
          ...this.$route.query,
          ["consultant"]: "active",
        },
      });
      this.getConsultantListHandler();
    },
    selectConsultantHanlder(cid) {
      this.selectedConsultant = cid;
    },
    getConsultantListHandler() {
      this.consultantLoading = true;
      this.helperPost("branch-users-list", {
        role: "consultant",
      })
        .then((response) => {
          if (response.data.result == 1) {
            this.consultantList = response.data.list;
          }
          this.consultantLoading = false;
        })
        .catch((err) => {
          console.error(err);
          this.consultantLoading = false;
        });
    },
    getTariffListHandler() {
      this.tariffLoading = true;
      this.helperPost("tariff-single-list")
        .then((response) => {
          if (response.data.result == 1) {
            this.allTariffList = response.data.all.map((t) => ({
              ...t,
              price: Number(t.price),
              count: 1,
              selected: false,
            }));
            this.activeTariffList = response.data.active.map((t) => ({
              ...t,
              price: Number(t.price),
              count: 1,
              selected: false,
            }));
          }
          this.tariffLoading = false;
        })
        .catch((err) => {
          console.error(err);
          this.tariffLoading = false;
        });
    },
    buyTariffHandler() {
      if (!this.hasSelected) {
        toast("تعرفه مورد نظر خود را انتخاب کنید.", {
          type: "error",
        });
        return;
      }
      this.buyLoading = true;
      this.helperPost("tariff-single-buy", {
        tariffs: this.selectedPayload,
        with_credit: this.with_credit ? 1 : 0,
      })
        .then((response) => {
          if (response.data.result == 1) {
            if (response.data.data.pay == 1) {
              let link = response.data.data.url;
              window.open(link, "_blank");
            } else {
              this.$emit("tariffSingleBought");
              setTimeout(() => {
                toast("خرید تعرفه با موفقیت انجام شد.", {
                  type: "success",
                });
              }, 500);
            }
            this.getTariffListHandler();
            this.selectedPayload = [];
            this.historyBackHandler();
          } else {
            toast(response.data.msg, {
              type: "error",
            });
          }
          this.buyLoading = false;
        })
        .catch((err) => {
          toast("مشکلی پیش آمده! مجدد امتحان کنید.", {
            type: "error",
          });
          this.buyLoading = false;
          console.error(err);
        });
    },
    transferTariffHandler() {
      if (!this.hasSelected) {
        toast("تعرفه مورد نظر خود را انتخاب کنید.", {
          type: "error",
        });
        return;
      }
      this.transferLoading = true;
      this.helperPost("tariff-single-transform", {
        tariffs: this.selectedPayload,
        consultant_id: this.selectedConsultant,
      })
        .then((response) => {
          if (response.data.result == 1) {
            this.closeConsultantHandler();
            this.getTariffListHandler();
            this.selectedPayload = [];
            setTimeout(() => {
              toast(response.data.msg, {
                type: "success",
              });
            }, 500);
          } else {
            toast(response.data.msg, {
              type: "error",
            });
          }
          this.transferLoading = false;
        })
        .catch((err) => {
          toast("مشکلی پیش آمده! مجدد امتحان کنید.", {
            type: "error",
          });
          this.transferLoading = false;
          console.error(err);
        });
    },
  },
  mounted() {
    this.getTariffListHandler();
  },
};
</script>

<style scoped lang="scss">
.dark {
  .userTariff {
    background: #1e262f;

    .header {
      background: #101a23;
      color: #fff;
      box-shadow: 0 1px 3px 0 rgba(255, 255, 255, 0.1),
        0 1px 2px -1px rgba(255, 255, 255, 0.1);
      border-color: #242424;
    }

    .tariff-card {
      background: #101a23;
      border-color: #444648;
      box-shadow: 0 1px 4px rgba(255, 255, 255, 0.05);
    }

    .tariff-name {
      color: #fff;
    }

    .active-tariff-item {
      background: #101a23;
      border-color: #444648;
      box-shadow: 0 1px 4px rgba(255, 255, 255, 0.05);
    }

    .active-tariff-name {
      color: #fff;
    }

    .active-tariff-count {
      color: #ccc;
    }

    .tariff-checkbox {
      border: 2px solid #858a92;
      background: #3f3f40;
    }

    .counter-controls {
      background: #2e343c;
    }

    .c-val {
      color: #fff;
    }

    .summary-card {
      background: #101a23;
      box-shadow: 0 2px 12px rgba(255, 255, 255, 0.07);
    }

    .summary-card-title {
      color: #fff;
      border-color: #4d4d4f;
    }

    .summary-item-name {
      color: #c6cfde;
    }

    .summary-item-price {
      color: #fff;
    }

    .summary-item-qty {
      background: #414648;
    }

    .summary-divider {
      background: #4d4d4f;
    }

    .wallet-row {
      background: #414648;
      border-color: #4d4d4f;
    }

    .wallet-lbl {
      color: #fff;
    }

    .btn-transfer {
      background: transparent;
      border-color: #0096c7;

      &:hover {
        background: #0096c7;
        color: #fff;
      }
    }

    .bottom-fixed {
      background: #101a23;
      border-color: #4d4d4f;
      box-shadow: 0 -4px 24px rgba(255, 255, 255, 0.07);
    }

    .btn-transfer-mobile {
      background: transparent;
    }
  }

  .contractsOverlay,
  .purchaseOverlay {
    .overlayContent {
      background: #101a23;
      color: #fff;

      .contentHandle {
        background: #2e3a45;
      }

      .contentHeader {
        border-color: #1e2d38;

        .headerTitle {
          color: #fff;
        }

        .headerBackBtn {
          background: #1e2d38;
          color: #94a3b8;

          &:hover {
            background: #263545;
          }
        }
      }

      .contentMain {
        .summary-items {
          background: #1a2530;
        }

        .wallet-row {
          background: #1a2530;
          border-color: #1e3a4a;
        }

        .wallet-lbl {
          color: #fff;
        }

        .total-row {
          background: #1a2530;

          .total-lbl {
            color: #64748b;
          }

          .total-val {
            color: #fff;
          }
        }

        .mainList {
          .listThumb {
            border-color: transparent;

            &:hover {
              background: #1a2530;
            }

            &.selected {
              background: rgba(0, 150, 199, 0.15);
              border-color: #0096c7;

              .contentName {
                color: #38bdf8;
              }
            }

            .contentName {
              color: #cbd5e1;
            }

            .thumbCheck {
              border-color: #2e3a45;
              background: #1a2530;
            }
          }

          @media (max-width: 700px) {
            .listThumb {
              background: #1a2530;
              border-color: #1e2d38;

              &:hover {
                background: #1e2d38;
                border-color: #263545;
              }

              &.selected {
                background: linear-gradient(
                  135deg,
                  rgba(0, 150, 199, 0.2) 0%,
                  rgba(0, 150, 199, 0.08) 100%
                );
                border-color: #0096c7;
                box-shadow: 0 2px 10px rgba(0, 150, 199, 0.15);

                .contentName {
                  color: #38bdf8;
                  font-weight: 600;
                }

                .thumbCheck {
                  border-color: #0096c7;
                  background: #0096c7;
                  box-shadow: 0 0 0 3px rgba(0, 150, 199, 0.2);
                }
              }

              .thumbContent {
                .contentProfile {
                  background: linear-gradient(135deg, #1e3a4a, #0f2d3d);

                  img {
                    border-color: #101a23;
                  }
                }

                .contentName {
                  color: #cbd5e1;
                }
              }

              .thumbCheck {
                border-color: #2e3a45;
                background: #101a23;
              }
            }
          }
        }
      }

      .contentFooter {
        border-color: #1e2d38;

        .footerSubmit {
          background: linear-gradient(135deg, #0ea5e9, #0284c7);

          &:disabled {
            opacity: 0.35;
          }
        }
      }
    }
  }
}
.userTariff {
  position: fixed;
  inset: 0;
  z-index: 9999;
  background: #f9fafb;
  overflow-y: auto;
  scrollbar-width: none;
}

.header {
  background: #fff;
  border-bottom: 1px solid #eef0f4;
  position: sticky;
  top: 0;
  z-index: 100;
}

.header-inner {
  max-width: 1200px;
  margin: 0 auto;
  padding: 16px 24px;
  display: flex;
  align-items: center;
  justify-content: space-between;
}

.header-title {
  font-size: 1.25rem !important;
  font-family: "iranyekanB", sans-serif;
  font-weight: 500;
}

.back-btn {
  width: 36px;
  height: 36px;
  border-radius: 50%;
  border: none;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  transition: background 0.2s;

  i {
    font-size: 1.5rem;
  }
}

.page-wrapper {
  max-width: 1200px;
  margin: 0 auto;
  padding: 28px 24px 40px;
  display: grid;
  grid-template-columns: 1fr 340px;
  gap: 24px;
  align-items: start;
}

.col-main {
  display: flex;
  flex-direction: column;
  gap: 24px;
}

.section-title {
  font-size: 14px;
  font-weight: 600;
  color: #b0bac9;
  margin-bottom: -10px;
  padding-right: 4px;
  letter-spacing: 0.02em;
  text-transform: uppercase;
}

.section-title-sk {
  width: 92px;
  height: 24px;
  margin-bottom: -14px;
  border-radius: 9999px;
  background: rgb(163, 219, 213);
}

.active-tariffs-grid {
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 14px;
}

.active-tariff-item {
  background: #fff;
  border-radius: 16px;
  padding: 14px 16px;
  display: flex;
  flex-direction: column;
  gap: 10px;
  box-shadow: 0 1px 4px rgba(0, 0, 0, 0.05);
  border: 1px solid #f0f4f8;
  transition: box-shadow 0.2s;

  &:hover {
    box-shadow: 0 4px 14px rgba(0, 150, 199, 0.1);
  }
}

.active-tariff-top {
  display: flex;
  align-items: center;
  gap: 7px;
}

.active-tariff-item-sk {
  width: 100%;
  height: 64px;
  border-radius: 14px;
  background: rgb(163, 219, 213);
  box-shadow: 0 1px 4px rgba(0, 0, 0, 0.05);
}

.active-tariff-right {
  display: flex;
  align-items: center;
  gap: 10px;
}

.active-tariff-dot {
  width: 7px;
  height: 7px;
  border-radius: 50%;
  background: #22c55e;
  box-shadow: 0 0 0 3px rgba(34, 197, 94, 0.15);
  flex-shrink: 0;
}

.active-tariff-num {
  font-size: 22px;
  font-weight: 800;
  color: #0096c7;
  line-height: 1;
  font-variant-numeric: tabular-nums;
}

.active-tariff-label {
  font-size: 11px;
  color: #9aa3b5;
  font-weight: 500;
}

.active-tariff-name {
  font-size: 13px;
  font-weight: 600;
  color: #374151;
  line-height: 1.3;
}

.active-tariff-bottom {
  display: flex;
  align-items: baseline;
  gap: 4px;
}

.active-tariff-count {
  font-size: 12px;
  color: #9aa3b5;
  margin-top: 6px;
}

.active-tariff-badge {
  display: none;
  background: #f0fdf4;
  color: #16a34a;
  font-size: 11px;
  font-weight: 700;
  border-radius: 8px;
  padding: 4px 10px;
  border: 1px solid #bbf7d0;
  white-space: nowrap;
}

.tariff-list {
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  gap: 16px;
}

.tariff-card {
  background: #fff;
  border-radius: 14px;
  border: 1.5px solid #f0f4f8;
  cursor: pointer;
  transition: border-color 0.2s, box-shadow 0.2s, background 0.2s;
  overflow: hidden;
  box-shadow: 0 1px 4px rgba(0, 0, 0, 0.05);

  &:hover {
    border-color: #bae6fd;
    box-shadow: 0 2px 12px rgba(0, 150, 199, 0.08);
  }

  &.selected {
    border-color: #0096c7;
    background: #f0faff;
    box-shadow: 0 2px 14px rgba(14, 165, 233, 0.12);
  }
}
.tariff-card-sk {
  width: 100%;
  height: 72px;
  border-radius: 14px;
  background: rgb(163, 219, 213);
  box-shadow: 0 1px 4px rgba(0, 0, 0, 0.05);
}
.tariff-card:hover {
  box-shadow: 0 3px 14px rgba(0, 0, 0, 0.08);
}
.tariff-card.selected {
  border-color: #0096c7;
  box-shadow: 0 2px 14px rgba(14, 165, 233, 0.15);
}

.tariff-main {
  padding: 16px 18px;
  display: flex;
  align-items: center;
  justify-content: space-between;
}

.tariff-left {
  display: flex;
  flex-direction: column;
  gap: 4px;
}

.tariff-name {
  font-size: 16px;
  font-weight: 700;
  color: #1a1a2e;
  display: flex;
  align-items: center;
  gap: 6px;
}

.tariff-price-label {
  font-size: 13px;
  color: #b0bac9;
  margin-top: 3px;
}
.tariff-price-label strong {
  color: #0096c7;
  font-weight: 700;
}

.pill {
  font-size: 10px;
  font-weight: 700;
  background: #fef3c7;
  color: #d97706;
  border-radius: 20px;
  padding: 2px 8px;
}

.tariff-checkbox {
  width: 22px;
  height: 22px;
  border-radius: 50%;
  border: 2px solid #dde3ed;
  background: #f4f6f9;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
  transition: background 0.2s, border-color 0.2s, transform 0.15s;

  .tariff-card.selected & {
    background: #0096c7;
    border-color: #0096c7;
    transform: scale(1.1);
  }

  svg {
    display: none;
    .tariff-card.selected & {
      display: block;
    }
  }
}

.tariff-card.selected .tariff-checkbox svg {
  display: block;
}

.tariff-counter-row {
  display: grid;
  grid-template-rows: 0fr;
  transition: grid-template-rows 0.25s ease;
}
.tariff-card.selected .tariff-counter-row {
  grid-template-rows: 1fr;
}

.tariff-counter-inner {
  overflow: hidden;
}

.tariff-counter-wrap {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 0 18px 14px;
}

.counter-label {
  font-size: 12px;
  color: #b0bac9;
}

.counter-controls {
  display: flex;
  align-items: center;
  background: #e8f4fb;
  border-radius: 12px;
  overflow: hidden;
}

.c-btn {
  width: 34px;
  height: 34px;
  border: none;
  background: transparent;
  color: #0096c7;
  font-size: 20px;
  font-weight: 600;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  transition: background 0.15s;
}
.c-btn:hover {
  background: #e0f2fe;
}
.c-btn:active {
  background: #bae6fd;
}

.c-val {
  font-size: 18px;
  font-weight: 700;
  color: #1a1a2e;
  min-width: 32px;
  text-align: center;
}

.col-sidebar {
  position: sticky;
  top: 88px;
  display: flex;
  flex-direction: column;
  gap: 14px;
}

.summary-card {
  background: #fff;
  border-radius: 18px;
  padding: 20px;
  box-shadow: 0 2px 12px rgba(0, 0, 0, 0.07);
  display: flex;
  flex-direction: column;
  gap: 16px;
}

.summary-card-title {
  font-size: 15px;
  font-weight: 700;
  color: #1a1a2e;
  padding-bottom: 12px;
  border-bottom: 1px solid #f0f2f6;
}

.summary-items {
  display: flex;
  flex-direction: column;
  gap: 12px;
  min-height: 60px;
}

.summary-empty {
  text-align: center;
  color: #c0c8d8;
  font-size: 13px;
  padding: 10px 0;
}

.summary-item {
  display: flex;
  align-items: center;
  justify-content: space-between;
  font-size: 13px;
}

.summary-item-name {
  color: #4a5568;
  font-weight: 600;
}

.summary-item-right {
  display: flex;
  align-items: center;
  gap: 8px;
}

.summary-item-qty {
  background: #f0f9ff;
  color: #0284c7;
  font-size: 11px;
  font-weight: 700;
  border-radius: 6px;
  padding: 2px 7px;
}

.summary-item-price {
  color: #1a1a2e;
  font-weight: 700;
  font-size: 14px;
  white-space: nowrap;
}

.summary-divider {
  height: 1px;
  background: #f0f2f6;
}

.wallet-row {
  display: flex;
  align-items: center;
  justify-content: space-between;
  background: #f8fbff;
  border-radius: 12px;
  padding: 16px;
  border: 1px solid #e0f0ff;
}

.wallet-left-side {
  display: flex;
  align-items: center;
  gap: 10px;
}

.wallet-icon-wrap {
  width: 32px;
  height: 32px;
  border-radius: 50%;
  background: #fff0f6;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 16px;
}

.wallet-lbl {
  font-size: 14px;
  font-weight: 600;
  color: #1a1a2e;
  margin-bottom: 6px;
}
.wallet-bal {
  font-size: 12px;
  color: #0284c7;
  font-weight: 600;
}

.toggle {
  position: relative;
  width: 44px;
  height: 24px;
}
.toggle input {
  opacity: 0;
  width: 0;
  height: 0;
}
.slider {
  position: absolute;
  inset: 0;
  background: #d1d9e6;
  border-radius: 24px;
  cursor: pointer;
  transition: background 0.25s;
}
.slider::before {
  content: "";
  position: absolute;
  width: 18px;
  height: 18px;
  border-radius: 50%;
  background: #fff;
  top: 3px;
  right: 3px;
  transition: transform 0.25s;
  box-shadow: 0 1px 4px rgba(0, 0, 0, 0.15);
}
.toggle input:checked + .slider {
  background: #0096c7;
}
.toggle input:checked + .slider::before {
  transform: translateX(-20px);
}

.total-row {
  display: flex;
  align-items: baseline;
  justify-content: space-between;
}
.total-lbl {
  font-size: 13px;
  color: #9aa3b5;
}
.total-val {
  font-size: 22px;
  font-weight: 800;
  color: #1a1a2e;
}
.total-val span {
  font-size: 12px;
  font-weight: 500;
  color: #9aa3b5;
  margin-right: 3px;
}

.btn-buy {
  width: 100%;
  height: 46px;
  display: flex;
  align-items: center;
  justify-content: center;
  background: linear-gradient(135deg, #0096c7, #0284c7);
  color: #fff;
  border: none;
  border-radius: 13px;
  padding: 15px 0;
  font-size: 15px;
  font-weight: 700;
  cursor: pointer;
  box-shadow: 0 4px 14px rgba(14, 165, 233, 0.35);
  transition: opacity 0.2s, transform 0.1s;
  text-align: center;
}
.btn-buy:hover {
  opacity: 0.92;
}
.btn-buy:active {
  transform: scale(0.98);
}
.btn-buy:disabled {
  opacity: 0.4;
  cursor: not-allowed;
  box-shadow: none;
}

.btn-transfer {
  width: 100%;
  height: 46px;
  display: flex;
  align-items: center;
  justify-content: center;
  background: #fff;
  color: #0284c7;
  border: 1.5px solid #bae6fd;
  border-radius: 13px;
  padding: 14px 0;
  font-size: 15px;
  font-weight: 700;
  cursor: pointer;
  transition: background 0.15s, transform 0.1s;
  text-align: center;
}
.btn-transfer:hover {
  background: #f0f9ff;
}
.btn-transfer:active {
  transform: scale(0.98);
}
.btn-transfer:disabled {
  opacity: 0.4;
  cursor: not-allowed;
}

.bottom-fixed {
  display: none;
}

@media (max-width: 900px) {
  .tariff-list {
    grid-template-columns: 1fr;
  }
  .active-tariffs-grid {
    grid-template-columns: 1fr 1fr;
  }
}

@media (max-width: 700px) {
  .page-wrapper {
    grid-template-columns: 1fr;
    padding: 16px 16px 200px;
    gap: 20px;
  }
  .col-sidebar {
    display: none;
  }

  .back-btn i {
    font-size: 1.25rem;
  }

  .active-tariffs-grid {
    grid-template-columns: 1fr 1fr;
  }

  .active-tariff-item.twoColumn,
  .active-tariff-item-sk.twoColumn {
    grid-column: span 2;
  }

  .tariff-list {
    grid-template-columns: 1fr;
  }

  .mobile-total-row {
    display: flex;
    align-items: baseline;
    justify-content: space-between;
    padding: 0 8px;
    margin-block: 4px;
  }
  .mobile-total-lbl {
    font-size: 15px;
    color: #9aa3b5;
  }
  .mobile-total-val {
    font-size: 18px;
    font-weight: 800;
    color: #1a1a2e;
  }
  .mobile-total-val span {
    font-size: 12px;
    font-weight: 500;
    color: #9aa3b5;
    margin-right: 3px;
  }

  .bottom-fixed {
    display: block;
    position: fixed;
    bottom: 0;
    left: 0;
    right: 0;
    background: #fff;
    padding: 18px 18px 24px;
    z-index: 200;
    backdrop-filter: blur(12px);
    background: rgba(255, 255, 255, 0.96);
    box-shadow: 0 -8px 32px rgba(0, 0, 0, 0.1);

    &::before {
      content: "";
      position: absolute;
      top: 0;
      left: 0;
      right: 0;
      height: 1px;
      background: linear-gradient(90deg, #0096c7, #38bdf8, #0096c7);
      background-size: 200% 100%;
      animation: shimmer 2.5s infinite linear;
    }
  }

  @keyframes shimmer {
    0% {
      background-position: 200% 0;
    }
    100% {
      background-position: -200% 0;
    }
  }

  .btn-row {
    display: grid;
    grid-template-columns: 1fr 1fr;
    gap: 16px;

    &.singleColumn {
      grid-template-columns: 100%;
    }
  }

  .btn-buy-mobile {
    height: 50px;
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 7px;
    background: linear-gradient(135deg, #0077b6, #0096c7 60%, #00b4d8);
    color: #fff;
    border: none;
    border-radius: 14px;
    font-size: 14px;
    font-weight: 700;
    cursor: pointer;
    box-shadow: 0 4px 16px rgba(0, 150, 199, 0.45),
      inset 0 1px 0 rgba(255, 255, 255, 0.2);
    transition: transform 0.15s, box-shadow 0.15s;
    position: relative;
    overflow: hidden;

    // shimmer روی دکمه
    &::after {
      content: "";
      position: absolute;
      top: 0;
      left: -60%;
      width: 40%;
      height: 100%;
      background: linear-gradient(
        90deg,
        transparent,
        rgba(255, 255, 255, 0.18),
        transparent
      );
      transform: skewX(-20deg);
      animation: btnShine 3s infinite;
    }

    &:active {
      transform: scale(0.96);
      box-shadow: 0 2px 8px rgba(0, 150, 199, 0.3);
    }

    &:disabled {
      opacity: 0.38;
      cursor: not-allowed;
      box-shadow: none;
      &::after {
        display: none;
      }
    }
  }

  @keyframes btnShine {
    0% {
      left: -60%;
    }
    60%,
    100% {
      left: 120%;
    }
  }

  .btn-transfer-mobile {
    height: 50px;
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 7px;
    background: #f0f9ff;
    color: #0077b6;
    border: 1.5px solid #7dd3fc;
    border-radius: 14px;
    font-size: 14px;
    font-weight: 700;
    cursor: pointer;
    transition: background 0.15s, transform 0.15s, border-color 0.15s;

    &:hover {
      background: #e0f2fe;
      border-color: #38bdf8;
    }

    &:active {
      transform: scale(0.96);
      background: #bae6fd;
    }

    &:disabled {
      opacity: 0.38;
      cursor: not-allowed;
    }
  }

  .wallet-lbl {
    margin-bottom: 8px;
  }

  .header-inner {
    padding: 9px 16px;
  }
}

.whiteLoader {
  width: 24px;
  height: 24px;
  border-radius: 50%;
  display: inline-block;
  border-top: 3px solid #fff;
  border-right: 3px solid transparent;
  box-sizing: border-box;
  animation: rotation 1s linear infinite;
}

.contractsOverlay,
.purchaseOverlay {
  position: fixed;
  inset: 0;
  background: rgba(0, 0, 0, 0.45);
  z-index: 300;
  display: none;
  align-items: center;
  justify-content: center;
  backdrop-filter: blur(1px);

  &.open {
    display: flex;
  }

  .overlayContent {
    background: #fff;
    border-radius: 14px;
    width: 420px;
    max-width: 95vw;
    max-height: 80vh;
    display: flex;
    flex-direction: column;
    overflow: hidden;
    box-shadow: 0 20px 60px rgba(0, 0, 0, 0.2);
    animation: modalIn 0.25s ease;

    .contentHandle {
      display: none;
    }

    .contentHeader {
      padding: 16px 20px;
      border-bottom: 1px solid #e5e7eb;
      display: flex;
      align-items: center;
      justify-content: space-between;
      flex-shrink: 0;

      .headerTitle {
        font-size: 1rem;
        font-family: "iranyekanB", sans-serif;
      }

      .headerBackBtn {
        width: 32px;
        height: 32px;
        border-radius: 9999px;
        border: none;
        background: #f4f6fb;
        cursor: pointer;
        font-size: 16px;
        display: flex;
        align-items: center;
        justify-content: center;
        color: #6b7280;
      }
    }

    .contentMain {
      overflow-y: auto;
      flex: 1;
      padding: 0 16px;

      .mainList {
        padding-block: 8px;

        .listThumbSk {
          width: 100%;
          height: 62px;
          border-radius: 10px;
          background: rgb(163, 219, 213);

          &:not(:last-child) {
            margin-bottom: 10px;
          }
        }

        .listThumb {
          display: flex;
          align-items: center;
          gap: 12px;
          padding: 10px 12px;
          border-radius: 10px;
          cursor: pointer;
          transition: all 0.15s;
          border: 1px solid transparent;

          &:not(:last-child) {
            margin-bottom: 6px;
          }

          &:hover {
            background: #f4f6fb;
          }

          &:active {
            transform: scale(0.985);
          }

          &.selected {
            background: #0096c722;
            border-color: #0096c7;

            .thumbCheck {
              border-color: #0096c7;
              background: #0096c7;

              &::after {
                content: "";
                width: 6px;
                height: 6px;
                display: block;
                background: #fff;
                border-radius: 9999px;
              }
            }
          }

          .thumbContent {
            flex-grow: 1;
            display: flex;
            align-items: center;
            gap: 12px;

            .contentProfile {
              width: 42px;
              height: 42px;
              flex-shrink: 0;

              img {
                width: 100%;
                height: 100%;
                object-fit: cover;
                border-radius: 9999px;
              }
            }

            .contentName {
              font-size: 14px;
            }
          }

          .thumbCheck {
            width: 18px;
            height: 18px;
            border-radius: 50%;
            border: 2px solid #e5e7eb;
            flex-shrink: 0;
            transition: border-color 0.2s, background 0.2s;
            display: flex;
            align-items: center;
            justify-content: center;
          }
        }
      }
    }

    .contentFooter {
      padding: 12px 16px;
      border-top: 1px solid #e5e7eb;
      flex-shrink: 0;

      .footerSubmit {
        display: flex;
        align-items: center;
        justify-content: center;
        background: #0096c7;
        color: #fff;
        width: 100%;
        height: 48px;
        padding: 0 12px;
        border-radius: 10px;
        border: none;
        font-size: 14px;
        font-weight: 700;
        cursor: pointer;
        transition: opacity 0.2s, transform 0.1s;
      }
    }
  }
}

@media (max-width: 700px) {
  .contractsOverlay,
  .purchaseOverlay {
    align-items: flex-end;

    .overlayContent {
      width: 100%;
      max-width: none;
      padding: 0 20px 36px;
      border-radius: 24px 24px 0 0;
      animation: modalUp 0.35s ease;

      &.contractsContent {
        padding-bottom: 26px;

        .contentFooter {
          padding-top: 20px;
        }
      }

      .contentHandle {
        display: block;
        width: 40px;
        height: 4px;
        background: #e2e8f0;
        border-radius: 4px;
        margin: 14px auto 20px;
      }

      .contentHeader {
        padding: 0;
        padding-bottom: 20px;
        border-color: transparent;

        .headerTitle {
          font-weight: 700;
          font-size: 1.1rem;
        }
      }

      .contentMain {
        padding-inline: 0;

        .mainList {
          .listThumb {
            display: flex;
            align-items: center;
            gap: 12px;
            padding: 10px 14px;
            border-radius: 14px;
            cursor: pointer;
            transition: background 0.15s, border-color 0.15s, transform 0.1s;
            border: 1.5px solid #f1f5f9;
            background: #fff;

            &:not(:last-child) {
              margin-bottom: 8px;
            }

            &:hover {
              background: #f8fafc;
              border-color: #e2e8f0;
            }

            &:active {
              transform: scale(0.985);
            }

            &.selected {
              background: linear-gradient(135deg, #e0f4fd 0%, #f0faff 100%);
              border-color: #0096c7;
              box-shadow: 0 2px 10px rgba(0, 150, 199, 0.12);

              .contentName {
                color: #0284c7;
                font-weight: 600;
              }

              .thumbCheck {
                border-color: #0096c7;
                background: #0096c7;
                box-shadow: 0 0 0 3px rgba(0, 150, 199, 0.15);

                &::after {
                  content: "";
                  width: 6px;
                  height: 6px;
                  display: block;
                  background: #fff;
                  border-radius: 9999px;
                }
              }
            }

            .thumbContent {
              flex-grow: 1;
              display: flex;
              align-items: center;
              gap: 12px;

              .contentProfile {
                width: 44px;
                height: 44px;
                flex-shrink: 0;
                border-radius: 9999px;
                /* حلقه دور عکس */
                padding: 2px;
                background: linear-gradient(135deg, #e0f4fd, #bae6fd);

                img {
                  width: 100%;
                  height: 100%;
                  object-fit: cover;
                  border-radius: 9999px;
                  border: 2px solid #fff;
                  display: block;
                }
              }

              .contentName {
                font-size: 14px;
                font-weight: 500;
                color: #1e293b;
                transition: color 0.15s;
              }
            }

            .thumbCheck {
              width: 20px;
              height: 20px;
              border-radius: 50%;
              border: 2px solid #cbd5e1;
              flex-shrink: 0;
              transition: border-color 0.2s, background 0.2s, box-shadow 0.2s;
              display: flex;
              align-items: center;
              justify-content: center;
              background: #fff;
            }
          }
        }

        .summary-items {
          background: #f8fafc;
          border-radius: 14px;
          padding: 14px;
          margin-bottom: 16px;
        }

        .wallet-row {
          border: 1px solid #bae6fd;
          margin-bottom: 16px;
          background: #f0f9ff;
        }

        .total-row {
          margin-bottom: 20px;
          padding: 14px;
          background: #f8fafc;
          border-radius: 12px;

          .total-lbl {
            font-size: 0.875rem;
            color: #9aa3b5;
          }

          .total-val {
            font-size: 1.5rem;
          }
        }
      }

      .contentFooter {
        padding: 0;
        border-color: transparent;

        .footerSubmit {
          height: 48px;
          background: linear-gradient(135deg, #0ea5e9, #0284c7);
          box-shadow: 0 4px 14px rgba(14, 165, 233, 0.35);
          border-radius: 13px;
          font-weight: 700;
          font-size: 1.1rem;
        }
      }
    }
  }
}

@keyframes modalIn {
  from {
    transform: scale(0.92);
    opacity: 0;
  }
  to {
    transform: scale(1);
    opacity: 1;
  }
}

@keyframes modalUp {
  from {
    transform: translateY(100%);
  }
  to {
    transform: translateY(0);
  }
}
</style>
